import React from 'react';
import './style.scss';
import { AdminDataUnit } from '../configConverter';
import Button from '../../../general/controls/button';
import AdminDataSectionUnit from './dataUnit';
import clsx from 'clsx';

interface Props {
  data: AdminDataUnit[];
  handleChange: (unit: AdminDataUnit, value: any) => any;
  header?: string;
  description?: string;
  button?: {
    onClick?: () => any;
    loading?: boolean;
    title: string;
  };
  simplified?: boolean;
}

const AdminDataSection = ({
  header,
  description,
  data,
  button,
  handleChange,
  simplified = false
}: Props) => (
  <div className={clsx('admin-data-section', simplified && 'simplified')}>
    {header && <h2 className='admin-data-section-header'>{header}</h2>}
    {description && (
      <p className='admin-data-section-description'>{description}</p>
    )}
    <div className='admin-data-section-block'>
      {data.map((unit, index) => (
        <AdminDataSectionUnit
          key={index}
          unit={unit}
          setValue={(newValue) => handleChange(unit, newValue)}
          simplified={simplified}
        />
      ))}
      {button && (
        <Button
          onClick={button.onClick}
          color='default'
          className='admin-data-section-block-button'
          loading={button.loading}
        >
          {button.title}
        </Button>
      )}
    </div>
  </div>
);

export default AdminDataSection;
